const activities = [
  {
    number: '01',
    title: 'Water Treatment',
    type: 'light-blue',
    icon: 'ri-drop-line',
    items: ['Drinking water supply', 'Industrial water treatment', 'Condensate treatment'],
  },
  {
    number: '02',
    title: 'Wastewater Treatment',
    type: 'gradient',
    icon: 'ri-filter-3-line',
    items: ['Wastewater purification', 'High-mineralized wastewater'],
  },
  {
    number: '03',
    title: 'Circulation Systems',
    type: 'icon',
    icon: 'ri-refresh-line',
    items: ['ZLD systems', 'Cooling systems'],
  },
  {
    number: '04',
    title: 'Automation',
    type: 'photo',
    photo: 'https://public.readdy.ai/ai/img_res/2ac69a1f3e1108cf13b32db8acaa7c82.jpg',
    icon: 'ri-cpu-line',
    items: ['APCS', 'System integration'],
  },
  {
    number: '05',
    title: 'Desalination',
    type: 'dark',
    icon: 'ri-water-flash-line',
    items: ['Stationary units', 'Mobile units'],
  },
  {
    number: '06',
    title: 'Precious Metal Extraction',
    type: 'light-blue',
    icon: 'ri-copper-coin-line',
    items: ['Valuable component extraction technologies'],
  },
  {
    number: '07',
    title: 'Laboratory Testing',
    type: 'icon',
    icon: 'ri-test-tube-line',
    items: ['Water analysis and testing'],
  },
  {
    number: '08',
    title: 'Component Manufacturing',
    type: 'gradient',
    icon: 'ri-settings-3-line',
    items: ['EDI modules', 'Membrane elements', 'DTRO modules'],
  },
];

export default function KeyActivities() {
  return (
    <section id="activities" className="bg-gradient-to-br from-[#F5F9FF] via-white to-[#EEF5FF] py-16 sm:py-24 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">

        {/* Section Header */}
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-[2px] bg-[#0066FF]"></div>
          <span className="text-xs uppercase tracking-[3px] text-[#0066FF] font-bold">Key Activities</span>
        </div>
        <h2 className="text-[32px] sm:text-[40px] lg:text-[52px] font-black text-[#0A1628] uppercase leading-none mb-10 sm:mb-16 tracking-tight">
          COMPREHENSIVE<br />WATER SOLUTIONS
        </h2>

        {/* Row 1: 4 cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-5">

          {/* 01 — Light blue */}
          <div className="rounded-[24px] bg-[#E8F4FF] p-6 lg:p-8 flex flex-col min-h-[220px] lg:min-h-[280px] cursor-pointer border-2 border-transparent hover:border-[#0066FF] hover:shadow-lg transition-all">
            <span className="text-[60px] lg:text-[80px] font-black text-[#0066FF] leading-none opacity-20 block h-[48px] lg:h-[60px] overflow-hidden">01</span>
            <div className="flex-1 min-h-[40px] lg:min-h-[60px]"></div>
            <div className="w-10 h-10 flex items-center justify-center mb-3">
              <i className="ri-drop-line text-[28px] text-[#0066FF]"></i>
            </div>
            <div className="text-base font-black text-[#0A1628] uppercase tracking-wide mb-3">Water Treatment</div>
            <ul className="space-y-1 min-h-[60px]">
              {['Drinking water supply', 'Industrial water treatment', 'Condensate treatment'].map((item, i) => (
                <li key={i} className="flex items-center gap-2 text-[13px] text-[#4A5568]">
                  <div className="w-1 h-1 rounded-full bg-[#0066FF] flex-shrink-0"></div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* 02 — Gradient */}
          <div className="rounded-[24px] bg-gradient-to-br from-[#0066FF] to-[#00D4FF] p-6 lg:p-8 flex flex-col min-h-[220px] lg:min-h-[280px] cursor-pointer hover:shadow-lg transition-shadow">
            <span className="text-[60px] lg:text-[80px] font-black text-white leading-none opacity-20 block h-[48px] lg:h-[60px] overflow-hidden">02</span>
            <div className="flex-1 min-h-[40px] lg:min-h-[60px]"></div>
            <div className="w-10 h-10 flex items-center justify-center mb-3">
              <i className="ri-filter-3-line text-[28px] text-white"></i>
            </div>
            <div className="text-base font-black text-white uppercase tracking-wide mb-3">Wastewater Treatment</div>
            <ul className="space-y-1 min-h-[60px]">
              {['Wastewater purification', 'High-mineralized wastewater'].map((item, i) => (
                <li key={i} className="flex items-center gap-2 text-[13px] text-white/80">
                  <div className="w-1 h-1 rounded-full bg-white flex-shrink-0"></div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* 03 — Icon card (white with blue border) */}
          <div className="rounded-[24px] border-2 border-[#E8F0FF] bg-white p-6 lg:p-8 flex flex-col min-h-[220px] lg:min-h-[280px] cursor-pointer hover:border-[#0066FF] hover:shadow-lg transition-all">
            <span className="text-[60px] lg:text-[80px] font-black text-[#0A1628] leading-none opacity-[0.06] block h-[48px] lg:h-[60px] overflow-hidden">03</span>
            <div className="flex-1 min-h-[40px] lg:min-h-[60px]"></div>
            <div className="w-10 h-10 flex items-center justify-center mb-3">
              <i className="ri-refresh-line text-[28px] text-[#0066FF]"></i>
            </div>
            <div className="text-base font-black text-[#0A1628] uppercase tracking-wide mb-3">Circulation Systems</div>
            <ul className="space-y-1 min-h-[60px]">
              {['ZLD systems', 'Cooling systems'].map((item, i) => (
                <li key={i} className="flex items-center gap-2 text-[13px] text-[#4A5568]">
                  <div className="w-1 h-1 rounded-full bg-[#0066FF] flex-shrink-0"></div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* 04 — Photo with overlay */}
          <div className="rounded-[24px] overflow-hidden relative min-h-[220px] lg:min-h-[280px] cursor-pointer hover:shadow-lg transition-shadow">
            <img
              src="https://readdy.ai/api/search-image?query=industrial%20automation%20control%20panel%20SCADA%20system%20water%20treatment%20plant%20professional%20engineering%20monochrome%20dark%20atmospheric%20high%20contrast%20detailed%20machinery%20screens&width=600&height=520&seq=ka-photo-04&orientation=portrait"
              alt="Automation"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-[#0A1628]/60"></div>
            <div className="relative z-10 p-6 lg:p-8 flex flex-col h-full">
              <span className="text-[60px] lg:text-[80px] font-black text-white leading-none opacity-20 block h-[48px] lg:h-[60px] overflow-hidden">04</span>
              <div className="flex-1 min-h-[40px] lg:min-h-[60px]"></div>
              <div className="w-10 h-10 flex items-center justify-center mb-3">
                <i className="ri-cpu-line text-[28px] text-[#00D4FF]"></i>
              </div>
              <div className="text-base font-black text-white uppercase tracking-wide mb-3">Automation</div>
              <ul className="space-y-1 min-h-[60px]">
                {['APCS', 'System integration'].map((item, i) => (
                  <li key={i} className="flex items-center gap-2 text-[13px] text-white/80">
                    <div className="w-1 h-1 rounded-full bg-[#00D4FF] flex-shrink-0"></div>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Row 2: 4 cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">

          {/* 05 — Dark */}
          <div className="rounded-[24px] bg-[#0A1628] p-6 lg:p-8 flex flex-col min-h-[220px] lg:min-h-[280px] cursor-pointer hover:shadow-lg transition-shadow">
            <span className="text-[60px] lg:text-[80px] font-black text-white leading-none opacity-10 block h-[48px] lg:h-[60px] overflow-hidden">05</span>
            <div className="flex-1 min-h-[40px] lg:min-h-[60px]"></div>
            <div className="w-10 h-10 flex items-center justify-center mb-3">
              <i className="ri-water-flash-line text-[28px] text-[#00D4FF]"></i>
            </div>
            <div className="text-base font-black text-white uppercase tracking-wide mb-3">Desalination</div>
            <ul className="space-y-1 min-h-[60px]">
              {['Stationary units', 'Mobile units'].map((item, i) => (
                <li key={i} className="flex items-center gap-2 text-[13px] text-white/60">
                  <div className="w-1 h-1 rounded-full bg-[#00D4FF] flex-shrink-0"></div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* 06 — Light blue */}
          <div className="rounded-[24px] bg-[#E8F4FF] p-6 lg:p-8 flex flex-col min-h-[220px] lg:min-h-[280px] cursor-pointer border-2 border-transparent hover:border-[#0066FF] hover:shadow-lg transition-all">
            <span className="text-[60px] lg:text-[80px] font-black text-[#0066FF] leading-none opacity-20 block h-[48px] lg:h-[60px] overflow-hidden">06</span>
            <div className="flex-1 min-h-[40px] lg:min-h-[60px]"></div>
            <div className="w-10 h-10 flex items-center justify-center mb-3">
              <i className="ri-copper-coin-line text-[28px] text-[#0066FF]"></i>
            </div>
            <div className="text-base font-black text-[#0A1628] uppercase tracking-wide mb-3">Precious Metal Extraction</div>
            <ul className="space-y-1 min-h-[60px]">
              {['Valuable component extraction technologies'].map((item, i) => (
                <li key={i} className="flex items-center gap-2 text-[13px] text-[#4A5568]">
                  <div className="w-1 h-1 rounded-full bg-[#0066FF] flex-shrink-0"></div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* 07 — Icon card */}
          <div className="rounded-[24px] border-2 border-[#E8F0FF] bg-white p-6 lg:p-8 flex flex-col min-h-[220px] lg:min-h-[280px] cursor-pointer hover:border-[#0066FF] hover:shadow-lg transition-all">
            <span className="text-[60px] lg:text-[80px] font-black text-[#0A1628] leading-none opacity-[0.06] block h-[48px] lg:h-[60px] overflow-hidden">07</span>
            <div className="flex-1 min-h-[40px] lg:min-h-[60px]"></div>
            <div className="w-10 h-10 flex items-center justify-center mb-3">
              <i className="ri-test-tube-line text-[28px] text-[#0066FF]"></i>
            </div>
            <div className="text-base font-black text-[#0A1628] uppercase tracking-wide mb-3">Laboratory Testing</div>
            <ul className="space-y-1 min-h-[60px]">
              {['Water analysis and testing'].map((item, i) => (
                <li key={i} className="flex items-center gap-2 text-[13px] text-[#4A5568]">
                  <div className="w-1 h-1 rounded-full bg-[#0066FF] flex-shrink-0"></div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* 08 — Gradient */}
          <div className="rounded-[24px] bg-gradient-to-br from-[#0066FF] to-[#00D4FF] p-6 lg:p-8 flex flex-col min-h-[220px] lg:min-h-[280px] cursor-pointer hover:shadow-lg transition-shadow">
            <span className="text-[60px] lg:text-[80px] font-black text-white leading-none opacity-20 block h-[48px] lg:h-[60px] overflow-hidden">08</span>
            <div className="flex-1 min-h-[40px] lg:min-h-[60px]"></div>
            <div className="w-10 h-10 flex items-center justify-center mb-3">
              <i className="ri-settings-3-line text-[28px] text-white"></i>
            </div>
            <div className="text-base font-black text-white uppercase tracking-wide mb-3">Component Manufacturing</div>
            <ul className="space-y-1 min-h-[60px]">
              {['EDI modules', 'Membrane elements', 'DTRO modules'].map((item, i) => (
                <li key={i} className="flex items-center gap-2 text-[13px] text-white/80">
                  <div className="w-1 h-1 rounded-full bg-white flex-shrink-0"></div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
}
